import type { ReactElement } from 'react';

import { useIsLargeScreen } from '@bestseller-bit/frontend-community.theme.buying-theme';
import Skeleton from '@mui/material/Skeleton';

const StandardTextLoading = (): ReactElement => {
    const isLargeScreen = useIsLargeScreen();

    return (
        <Skeleton
            variant="rectangular"
            width="100%"
            height={isLargeScreen ? 80 : 68}
        />
    );
};

export { StandardTextLoading };
